import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmEmailFacade } from './confirm-email.facade';
import { COMMON_IMPORTS } from '../../../global-misc/common-imports';

@Component({
  selector: 'app-confirm-email',
  imports: [...COMMON_IMPORTS],
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css']
})
export class ConfirmEmailComponent implements OnInit, OnDestroy {
  email: string = '';
  constructor(private facade: ConfirmEmailFacade) { }

  async ngOnInit() {
    this.email = await this.facade.start();
  }

  async check() {
    await this.facade.check();
  }

  async resend() {
    await this.facade.resend();
  }

  async signOut() {
    await this.facade.signOut();
  }

  public async ngOnDestroy() {
    this.facade.destroy();
  }
}
